import {
  Box,
  lgBumps,
  mdBumps,
  PrimaryButton,
  SecondaryButton,
} from '@wrisk/ui-components'
import type { TFunction } from 'i18next'
import { useCallback } from 'react'
import React from 'react'
import { useFormContext } from 'react-hook-form'

import { useErrorHandlingAsyncCallback } from '../../../../hooks/errors'
import { TExtends, TKeyBuilder } from '../../../../infrastructure/internationalisation'
import { InputConfig } from '../../../../state/configuration'
import { FormItems } from '../FormItems'
import { InputLoopMeta } from './InputLoopMeta'

export interface InputLoopFormProps {
  item: InputConfig<InputLoopMeta>
  index: number
  t: TFunction
  tKey: TKeyBuilder
  onCancel?: (index: number) => void
  onConfirm?: (index: number) => void
  errorClassName?: string
}

export const InputLoopForm = ({
  errorClassName,
  onConfirm,
  onCancel,
  item,
  index,
  tKey,
  t,
}: InputLoopFormProps) => {
  const prefix = `${item.name}.${index}`

  const { trigger } = useFormContext()

  const handleCancel = useCallback(() => {
    onCancel?.(index)
  }, [index, onCancel])

  const { loading, execute } = useErrorHandlingAsyncCallback(async () => {
    const isValid = await trigger(
      item.meta?.form.map((input) => `${prefix}.${input.name}`),
    )

    if (isValid) {
      onConfirm?.(index)
    }
  })

  return (
    <Box
      borderWidth={1}
      gap={lgBumps}
      p={mdBumps}
      display='flex'
      flexDirection='column'
      width={1}
    >
      <FormItems
        t={t}
        tKey={TExtends(tKey, item.name, 'inputs')}
        config={item.meta?.form ?? []}
        prefix={prefix}
        variant='nested'
        errorClassName={errorClassName}
      />
      <Box display='flex' flexWrap='nowrap' gap={2} justifyContent='flex-start'>
        <PrimaryButton loading={loading} onClick={execute}>
          Confirm
        </PrimaryButton>
        <SecondaryButton onClick={handleCancel}>Cancel</SecondaryButton>
      </Box>
    </Box>
  )
}
